// CC-159 — Team Review delivery visibility ("Sent X of Y" + per-recipient status) and the editor-only test email.
import { useState } from "react";
import api from "@/lib/api";

const LABELS = {
  queued: "Sent", sent: "Sent", delivered: "Delivered", delayed: "Delayed", bounced: "Bounced",
  complained: "Spam complaint", failed: "Failed", undelivered: "Undelivered", mocked: "Not sent (mocked)",
};
const TONE = {
  delivered: "bg-[#e6f9f2] text-[#0e6b52]", queued: "bg-[#eef1f6] text-[#0e1420]", sent: "bg-[#eef1f6] text-[#0e1420]",
  delayed: "bg-[#fef3d9] text-[#8a5a1a]", bounced: "bg-[#fde8e8] text-[#991b1b]", complained: "bg-[#fde8e8] text-[#991b1b]",
  failed: "bg-[#fde8e8] text-[#991b1b]", undelivered: "bg-[#fde8e8] text-[#991b1b]", mocked: "bg-[#f5f6f8] text-[#4b5563]",
};

export function deliveryKey(d) {
  if (!d) return null;
  return d.mocked ? "mocked" : d.delivery_status || null;
}

export function DeliverySummary({ summary }) {
  if (!summary) return null;
  return (
    <span className="font-semibold" data-testid="payroll-detail-team-review-delivery-summary">
      Sent {summary.sent} of {summary.total}
    </span>
  );
}

export function DeliveryChip({ delivery, testId }) {
  const k = deliveryKey(delivery);
  if (!k) return <span className="text-[11px] text-[color:var(--cc-ink-muted)]" data-testid={testId}>No send on file</span>;
  return (
    <span className={`inline-block px-2 py-0.5 rounded text-[11px] font-medium ${TONE[k] || TONE.queued}`}
          data-testid={testId} data-status={k} title={delivery?.error || ""}>
      {LABELS[k] || k}
    </span>
  );
}

export function SendTestEmailButton({ runId, slug, subjectKey }) {
  const [state, setState] = useState(null);
  const send = async () => {
    setState({ busy: true });
    try {
      const q = subjectKey ? `&subject_key=${encodeURIComponent(subjectKey)}` : "";
      const { data } = await api.post(`/payroll/runs/${runId}/team-review/send-test?tenant_slug=${slug}${q}`, {});
      setState({ ok: `Test email for ${data.subject_name} sent to ${data.to}${data.mocked ? " (mocked — Resend not configured here)" : ""}.` });
    } catch (e) {
      const d = e?.response?.data?.detail;
      setState({ err: d?.message || d || e.message });
    }
  };
  return (
    <span className="inline-flex items-center gap-2">
      <button type="button" onClick={send} disabled={state?.busy}
              className="px-2 py-1 rounded border border-[#dfe2e8] text-[11.5px] hover:bg-[#f5f6f8] disabled:opacity-50"
              data-testid="payroll-detail-team-review-send-test-btn">
        {state?.busy ? "Sending…" : "Send test email to me"}
      </button>
      {state?.ok && <span className="text-[11px] text-[#0e6b52]" data-testid="payroll-detail-team-review-send-test-ok">{state.ok}</span>}
      {state?.err && <span className="text-[11px] text-[#991b1b]" data-testid="payroll-detail-team-review-send-test-err">{String(state.err)}</span>}
    </span>
  );
}
